'use client'

import Image from 'next/image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom'

import { useTradeSlide } from './TradeSlideContext'

const copyrightYear = new Date().getFullYear()
const FALLBACK_IMAGE = '/images/footer-1.jpg'

export default function TradeFooterBanner() {
    const context = useTradeSlide()
    const currentSlide = context?.currentSlide

    const imageSrc = currentSlide?.footerImage?.src || FALLBACK_IMAGE
    const imageAlt = currentSlide?.footerImage?.alt || 'hive modern floral imagery'

    return (
        <div className="relative overflow-hidden">
            <Image
                src={imageSrc}
                alt={imageAlt}
                width={1800}
                height={300}
                quality={90}
                sizes="100vw"
                className="w-full h-auto"
            />
            <div className="absolute inset-0 flex items-center justify-center z-10">
                <div className="text-center">
                    <FontAwesomeIcon
                        icon={faHiveIconSmallLight}
                        className="inline text-primary text-4xl mb-1"
                        aria-hidden="true"
                    />
                    <div className="text-white text-md">Modern Design for the Home</div>
                </div>
            </div>
            <div className="absolute bottom-2 right-2 text-white z-10 text-right text-4xs">
                &copy; 2002-{copyrightYear} hive all rights reserved
            </div>
        </div>
    )
}
